// extracted by mini-css-extract-plugin
module.exports = {"rightRailWithSplitRow":"rightRailWithSplitRow___2Fh07","main":"main___1Yuh6","splitCol":"splitCol___2gKso"};